/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchInsuredDetailsDto } from './SearchInsuredDetailsDto';
import {
    SearchInsuredDetailsDtoFromJSON,
    SearchInsuredDetailsDtoFromJSONTyped,
    SearchInsuredDetailsDtoToJSON,
    SearchInsuredDetailsDtoToJSONTyped,
} from './SearchInsuredDetailsDto';

/**
 * 
 * @export
 * @interface SearchInsuredsResponse
 */
export interface SearchInsuredsResponse {
    /**
     * Total number of items matching the search criteria
     * @type {number}
     * @memberof SearchInsuredsResponse
     */
    totalCount: number;
    /**
     * Array of search results
     * @type {Array<SearchInsuredDetailsDto>}
     * @memberof SearchInsuredsResponse
     */
    items: Array<SearchInsuredDetailsDto>;
}

/**
 * Check if a given object implements the SearchInsuredsResponse interface.
 */
export function instanceOfSearchInsuredsResponse(value: object): value is SearchInsuredsResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchInsuredsResponseFromJSON(json: any): SearchInsuredsResponse {
    return SearchInsuredsResponseFromJSONTyped(json, false);
}

export function SearchInsuredsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInsuredsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(SearchInsuredDetailsDtoFromJSON)),
    };
}

export function SearchInsuredsResponseToJSON(json: any): SearchInsuredsResponse {
    return SearchInsuredsResponseToJSONTyped(json, false);
}

export function SearchInsuredsResponseToJSONTyped(value?: SearchInsuredsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(SearchInsuredDetailsDtoToJSON)),
    };
}

